<template>
  <!--table paging v-bind="$props"  -->
  <div class="form-group row">
    <div class="col-md-10" :class="{'whirl no-overlay':loading}">
      <div class="row" v-for="(item, index) in files" :key="index" v-if="!loading">
        <div class="col-3"><img :src="item.fullPath" width="300"></div>
      </div>
      <b-form-file v-model="file" :state="Boolean(file)" @change="upload" placeholder="Choose a file..."></b-form-file>
    </div>
  </div>
</template>

<script>
import {reactive, ref, computed, watch, onMounted, onUnmounted} from '@vue/composition-api'
import {uploadS3,uploadCsFile} from "@/api/cs/CsFileApi";

export default {
  props: {
    files: []
  },
  setup(props, context) {
    return {
      file: null,
      loading: false,
      ...actions(props.list, context)
    }
  }
}

function actions(list, context) {

  async function upload(event) {
    this.loading = true;
    var formData = new FormData();
    formData.append("mfile", event.target.files[0]);
    formData.append("newFileName", "abcd");
    formData.append("floderDiv", "BANNER"); /* AwsS3Floder.java */
    let result = await uploadS3(formData);
    this.files.push(result.data)
    let length = this.files;

    //this.files.splice(length)
    this.loading = false;
    console.log('$$ ImageUpload length;', length, 'this.files', this.files)
    context.emit('upload', this.files)
  }

  return {upload}
}
</script>
